import { Menu } from "antd";
import items from "./sideMenuItems";

export default function SideMenu() {
  return <Menu defaultSelectedKeys={["1"]} defaultOpenKeys={["sub1"]} mode="inline" theme="dark" items={items} />;
}
